module.exports = __webpack_public_path__ + "static/media/IntroShots2.6824ac06.mp4";